import React, { Component } from 'react';
import logo from "../images/logo.png";

export default class Navbar extends Component {


  render() {
          return (
              <div className={"navbar"}>
                  <div className={"container"}>
                      <a href="https://www.rottenburger-gruppe.de/">
                        <img src={logo} height={"100px"} />
                      </a>
                  </div>
              </div>
          )

  }

}


// WEBPACK FOOTER //
// ./src/components/Navbar.js